module.exports = " <div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-2\">\n      <div class=\"sidemenu\">\n        <ul class=\"billmenu\">\n          <li><a [routerLink]=\"['/home/Renewals']\"> Renewals App </a></li>\n          <!-- <li><a [routerLink]=\"['renewals-approval-grid']\"> Renewals</a></li> -->\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-10\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/renewal-approval/renewal-approval.component.html
// module id = ./src/app/recovery/renewal-approval/renewal-approval.component.html
// module chunks = main